import React from 'react'
import { RouteComponentProps } from 'react-router'
import { IGroupParam } from '../../types/router'
import { GreenThemeProvider } from '../../styles'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import { CreatePackForm } from '../../forms'
import { CombinedTitle, SlugValidateModal } from '../../components'

export const NewPackPage = ({
  match: {
    params: { groupId },
  },
}: RouteComponentProps<IGroupParam>) => (
  <GreenThemeProvider>
    <Main titleBlock={<CombinedTitle first="Untitled" second="Pack" />}>
      <Scrollable>
        <SettingFormsWrapper>
          <CreatePackForm groupId={groupId} />
        </SettingFormsWrapper>
      </Scrollable>
    </Main>
    <SlugValidateModal />
  </GreenThemeProvider>
)
